import './styles/index.scss';
import  styles from './App.module.scss';
import Header from '../widgets/Header/ui/Header/Header';
import RouterProvider from './providers/router/RouterProvider/RouterProvider';
import Footer from '../widgets/Footer/Footer';
import { ButtonUp } from '../shared/ui/ButtonUp/ButtonUp';


function App() {



  return (
    <div className={styles.app}>
      <Header/>
      <RouterProvider/>       
      <Footer/>

      <ButtonUp/>   
    </div>
  );
}

export default App;
